'use client';

import { useTranslations } from 'next-intl';
import React from 'react';
import { useTenant } from '@/providers/TenantProvider';
import OriginalGamesList from './original-games-list';

const OriginalGames = () => {
  const t = useTranslations('landing.original-games');
  const {
    tenantMachineName,
    tenantConfig: {
      settings: { showOriginalGamesTitle },
    },
  } = useTenant();

  return (
    <section className="overflow-hidden rounded-lg">
      <div className="flex w-full flex-col justify-between ">
        {showOriginalGamesTitle ? (
          <div className="flex flex-col items-center justify-center p-3 text-center">
            <div className="flex flex-wrap items-center justify-center space-x-2 font-bold vt-font-highlight-font-family vt-text-size-landing-page-medium sm:flex-nowrap rtl:space-x-reverse">
              {t.rich('title', {
                originals: () => <span>{t('originals')}</span>,
                tenantName: () => <span className="vt-colors-accents-accent-3-400">{t('tenantName')}</span>,
                games: () => <span>{t('games')}</span>,
              })}
            </div>
            <div className="flex items-center justify-center">
              <span className="vt-text-size-big">{t('description')}</span>
            </div>
          </div>
        ) : null}
        <OriginalGamesList type={`${tenantMachineName}-originals`} />
      </div>
    </section>
  );
};

export default OriginalGames;
